import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.boundKeydownHandler = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydownHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydownHandler)
  }

  open(event) {
    event.preventDefault()
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target !== this.modalTarget) return
    this.close()
  }

  handleKeydown(event) {
    if (event.key !== "Escape" || !this.hasModalTarget) return
    if (this.modalTarget.classList.contains("hidden")) return
    this.close()
  }
}
